import { IAppFeedbackRepository } from "../domain/repositories/IAppFeedbackRepository";
import { AppFeedbackUseCase } from "../domain/useCases/AppFeedbackUseCase";
import { AppFeedbackImpl } from "../data/AppFeedbackImpl";
import { AppFeedbackViewModel } from "../presentation/viewModel/AppFeedbackViewModel";
import { InjectionBinding, InjectionModule } from "app/di/DependencyInjections";

export class AppFeedbackInjection extends InjectionModule {
  private static readonly appFeedbackRepositoryToken = Symbol(
    "IAppFeedbackRepository",
  );
  private static readonly appFeedbackUseCaseToken =
    Symbol("AppFeedbackUseCase");
  private static readonly appFeedbackViewModelToken = Symbol(
    "AppFeedbackViewModel",
  );

  protected static override bindings: InjectionBinding[] = [
    {
      scope: "otherRepo",
      token: this.appFeedbackRepositoryToken,
      useClass: AppFeedbackImpl,
    },
    {
      scope: "otherRepo",
      token: this.appFeedbackUseCaseToken,
      useClass: AppFeedbackUseCase,
    },
    {
      scope: "viewModel",
      token: this.appFeedbackViewModelToken,
      useClass: AppFeedbackViewModel,
    },
  ];

  static getRepo(): IAppFeedbackRepository {
    return this.resolve(this.appFeedbackRepositoryToken);
  }

  static getUseCase(): AppFeedbackUseCase {
    return this.resolve(this.appFeedbackUseCaseToken);
  }
}
